const changeFace = () => {

	let exhibitionText = document.querySelector('.text'),
		exhibitionTextImg = document.querySelectorAll('.exhibition .text p a'),		
		exhibitionPoster = document.querySelectorAll('.exhibition-poster');	
	
	exhibitionTextImg.forEach(function(item) {

		item.addEventListener('click', (e) => {

			let itemClass = item.classList.value,
				width = document.documentElement.clientWidth;	

			for(let i = 0; i < exhibitionPoster.length; i++) {

				exhibitionPoster.forEach(function(el) {

					if (!el.classList.contains('hide')) {
						el.classList.add('hide');
					}
				});

				if (exhibitionPoster[i].classList.contains(itemClass)) {
					exhibitionPoster[i].classList.remove('hide');
					break;
				}				
			}

			if(width >= 992) {
				e.preventDefault();
			}

		});
	});
}
export default changeFace;